export default __webpack_public_path__ + "static/media/avatar_78.f4fa0f63.png";